import { type ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { usePermissions } from '@/hooks/usePermissions'

interface ProtectedRouteProps {
  permission: string
  children: ReactNode
}

export function ProtectedRoute({ permission, children }: ProtectedRouteProps) {
  const { hasPermission } = usePermissions()
  if (!hasPermission(permission)) return <Navigate to="/" replace />
  return <>{children}</>
}
